import { APPLY_FILTERS, RESET_FILTERS } from "./actions";
import { initialState } from "./context";



export default function ApplicationReducer(
   state = initialState,
   { type, payload }
) {
   switch (type) {
      case APPLY_FILTERS: {
         return { ...state, filtersReq:payload};
      }
      case RESET_FILTERS: {
         return { ...state, filtersReq:payload};
      }
      default:
         return state;
   }
}